module.exports = __webpack_public_path__ + "static/media/UserDiscount.8cd0b3e5.svg";